import AppStorage from './AppStorage';
import firebase from 'gatsby-plugin-firebase';
import client from './client';
import { vars } from '../reactive';
import { FORM_PAGES } from '../components/Form/types';
import { setFormPage } from '../reactive/actions';
import { checkLocalStorageSupport } from '../hooks/useCheckLocalStorageSupport';
import { LogoutAppUser } from './queries';

export const setLoginTokens = tokens => {
  AppStorage.set('tokens', tokens);
};

export const logout = async () => {
  try {
    let firebaseToken = null;
    if (firebase.messaging.isSupported()) {
      try {
        firebaseToken = await firebase?.messaging().getToken();
        await firebase?.messaging().deleteToken();
      } catch (e) {
        console.error('FIREBASE MESSAGING ERROR:', e);
      }
    }

    // Use GraphQL mutation to logout (remove FCM token)
    if (firebaseToken) {
      try {
        await client.mutate({
          mutation: LogoutAppUser,
          variables: { input: { firebase_token: firebaseToken } }
        });
      } catch (e) {
        console.error('GRAPHQL LOGOUT ERROR:', e);
      }
    }

    await firebase?.auth?.().signOut();
  } catch (e) {
    // user signed in from elsewhere
    console.error('FIREBASE ERROR ON LOGOUT:', e);
  }
  AppStorage.remove('tokens');
  AppStorage.remove('apollo-cache-persist');
  client.clearStore();
  client.cache.reset();
  vars.isLoggedIn(false);
};

export const clearPageAndLogout = async () => {
  return new Promise(resolve => {
    if (checkLocalStorageSupport()) {
      if (vars.isFormFillView()) {
        setFormPage(FORM_PAGES.FORM_SELECT);
        return;
      }
      setFormPage(FORM_PAGES.PRODUCTS);
    } else {
      setFormPage(FORM_PAGES.BROWSER_NOT_SUPPORTED);
    }
    requestAnimationFrame(async () => {
      await logout();
      resolve(true);
    });
  });
};
